import { Helmet } from "react-helmet";
import PageHero from "../components/reusables/hero/PageHero";
import IndustriesBody from "../components/industries/IndustriesBody";

export default function Industries() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/industries"
        />
        <meta
          name="description"
          content="Explore NTUNA.COM's ICT Solutions across industries from healthcare, education, construction, NGOs, tourism, hospitality and corporate sectors."
        />
        
        <meta
          property="og:description"
          content="Explore NTUNA.COM's ICT Solutions across industries from healthcare, education, construction, NGOs, tourism, hospitality and corporate sectors."
        />
        <meta property="og:title" content="NTUNA.COM | Industries We Serve" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Industries We Serve" />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Industries We Serve"
        />
        <meta
          name="twitter:description"
          content="Explore NTUNA.COM's ICT Solutions across industries from healthcare, education, construction, NGOs, tourism, hospitality and corporate sectors."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | Industries We Serve</title>
      </Helmet>
      <PageHero
        classes="world-bg"
        titleClasses="title uppercase ntuna-text-fill"
        title="Industries We Serve"
      />
      <IndustriesBody />
    </>
  );
}
